import getEnvVar from './getEnvVar';

export default (path) => {
  const baseUrl = getEnvVar('STATIC_ASSET_URL') || 'assets.kinside.com';
  return `https://${baseUrl}${path}`;
};
